import {
  PAY_TYPE_OPTIONS,
  type PayType,
} from '@/app/features/employee/emp-payroll';
import { Calendar03Icon, Clock01Icon } from '@/icons';
import SegmentedSwitch from './SalaryGrade/SegmentedSwitch';

const OPTIONS = PAY_TYPE_OPTIONS.map((option) => ({
  ...option,
  icon:
    option.value === 'DAILY' ? (
      <Clock01Icon size={16} />
    ) : (
      <Calendar03Icon size={16} />
    ),
}));

type Props = {
  value: PayType;
  onChange: (value: PayType) => void;
  disabled?: boolean;
};

/**
 * The Monthly / Daily switch shared by every payroll screen that works on one
 * population at a time, so it looks and reads the same wherever it appears.
 */
const PayBasisSwitch = ({ value, onChange, disabled }: Props) => (
  <SegmentedSwitch
    size="large"
    value={value}
    options={OPTIONS}
    onChange={onChange}
    disabled={disabled}
  />
);

export default PayBasisSwitch;
